import React, { useContext, useState, useEffect } from 'react';
import { AppContext } from './App';
import axios from 'axios';
import { SERVER_URL } from './config';
import './Invites.css';

const Invites = () => {
  const [invites, setInvites] = useState([]);
  const [filteredInvites, setFilteredInvites] = useState([]);
  const [typeFilter, setTypeFilter] = useState('');
  const [arrivingFilter, setArrivingFilter] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [currentInvite, setCurrentInvite] = useState(null);
  const [newName, setNewName] = useState('');
  const [newPhone, setNewPhone] = useState('');
  const [newArriving, setNewArriving] = useState('');
  const [copiedIndex, setCopiedIndex] = useState(null);
  const [editableFields, setEditableFields] = useState({});
  const [newRelationship, setNewRelationship] = useState('');
  const { user } = useContext(AppContext);
  const [searchQuery, setSearchQuery] = useState('');

  const relationshipOptions = [
    { value: 'חברים חתן', label: 'חברים חתן' },
    { value: 'חברים כלה', label: 'חברים כלה' },
    { value: 'חברים הורים', label: 'חברים הורים' },
    { value: 'משפחה חתן', label: 'משפחה חתן' },
    { value: 'משפחה כלה', label: 'משפחה כלה' },
    { value: 'אחר', label: 'אחר' }
  ];

const handleSearch = () => {
  const filteredResults = invites.filter((invite) =>
    invite.name.toLowerCase().includes(searchQuery.toLowerCase())
  );
  setFilteredInvites(filteredResults);
};


  useEffect(() => {
    get_invites();
  }, [user]);

  const get_invites = async () => {
    try {
        const token = localStorage.getItem('token'); // Get the stored token
        const response = await axios.get(`${SERVER_URL}get_invites`, {
            headers: {
                Authorization: `Token ${token}`, // Include the token in the header
            },
        });
        setInvites(response.data);
        setFilteredInvites(response.data); // Initialize filtered invites
    } catch (error) {
        console.error('Error getting invites', error);
    }
};

  

  const downloadData = async () => {
    try {
        const response = await axios.get(`${SERVER_URL}export-invites/`, {
            params: { user: user.user },
            headers: { Authorization: `Token ${localStorage.getItem('token')}` },
            responseType: 'blob',
        });

        // Create a link element to download the file
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'invites.xlsx');
        document.body.appendChild(link);
        link.click();
    } catch (error) {
        console.error(`Error downloading invites.xlsx`, error);
    }
};

  const handleEditClick = (invite) => {
    setCurrentInvite(invite);
    setNewName(invite.name);
    setNewPhone(invite.phon_number);
    setNewArriving(invite.arriving);
    setNewRelationship(invite.relationship);
    setShowModal(true);
  };

  const handleCancel = () => {
    setShowModal(false);
    setCurrentInvite(null);
  };

  const handleSave = async () => {
    try {
        const response = await axios.post(`${SERVER_URL}change_invite`, {
            invite: currentInvite.name,
            phone: newPhone,
            name: newName,
            arriving: newArriving,
            relationship: newRelationship,
        }, {
            headers: { Authorization: `Token ${localStorage.getItem('token')}` },
        });
        setShowModal(false);
        setCurrentInvite(null);
        get_invites();
    } catch (error) {
        console.error('Error changing invite', error);
    }
};


  // Filter handler
  useEffect(() => {
    const filtered = invites.filter((invite) => {
      const typeMatches = typeFilter ? invite.relationship === typeFilter : true;
      const arrivingMatches =
        arrivingFilter === '0'
          ? invite.arriving === 0
          : arrivingFilter === '>0'
          ? invite.arriving > 0
          : arrivingFilter === 'null'
          ? invite.arriving === null
          : true;
      return typeMatches && arrivingMatches;
    });
    setFilteredInvites(filtered);
  }, [typeFilter, arrivingFilter, invites]);


  const handleRemoveInvite = async (invite) => {
    if (window.confirm(`האם אתה בטוח שברצונך למחוק את ${invite.name} מרשימת המוזמנים?`)) {
        try {
            await axios.delete(`${SERVER_URL}remove_invites`, {
                params: { invite: invite.id },
                headers: { Authorization: `Token ${localStorage.getItem('token')}` },
            });
            get_invites();
        } catch (error) {
            console.error('Error removing invite', error);
        }
    }
};

const copyToClipboard = (url, index) => {
  navigator.clipboard.writeText(url).then(() => {
    setCopiedIndex(index);
    setTimeout(() => setCopiedIndex(null), 2000); // Reset "Copied" status after 2 seconds
  });
};


const calculateInviteStats = () => {
  const arrivingGreaterThanZero = invites.filter((i) => i.arriving > 0).length;
  const arrivingEqualZero = invites.filter((i) => i.arriving === 0).length;
  const arrivingUndefined = invites.filter((i) => i.arriving == null).length;
  const howMany = invites.reduce((sum, invite) => {
    // Ensure arriving is a number and not null/undefined
    return sum + (invite.arriving ? invite.arriving : 0);
  }, 0);
  
  return {
    total: invites.length,
    arrivingGreaterThanZero,
    arrivingEqualZero,
    arrivingUndefined,
    howMany,
  };
};

const stats = calculateInviteStats();

const handleCheckboxChange = (id) => {
  setEditableFields((prev) => ({
    ...prev,
    [id]: !prev[id],
  }));
};


  return (
    <div>
      {/* Filters */}
  <div className="page-container">
  {/* Stats Section */}
  <div className="stats-section">
  <label>סה"כ מוזמנים: <span className="highlight">{stats.total}</span></label>
  <label>אישרו הגעה: <span className="highlight">{stats.arrivingGreaterThanZero}</span></label>
  <label>סה"כ אורחים צפויים: <span className="highlight" style={{ color: 'green' }}>{stats.howMany}</span></label>
  <label>לא מגיעים: <span className="highlight"  style={{ color: 'red' }}>{stats.arrivingEqualZero}</span></label>
  <label>
  לא ידוע: <span className="highlight">{stats.arrivingUndefined}</span>
</label>
</div>


  {/* Filters Section */}
  <div className="filters-section">
    <label>
      סנן לפי סוג
      <select value={typeFilter} onChange={(e) => setTypeFilter(e.target.value)}>
        <option value="">הכל</option>
        <option value="חברים חתן">חברים חתן</option>
        <option value="חברים כלה">חברים כלה</option>
        <option value="חברים הורים">חברים הורים</option>
        <option value="משפחה חתן">משפחה חתן</option>
        <option value="משפחה כלה">משפחה כלה</option>
        <option value="אחר">אחר</option>
      </select>
    </label>
    <label>
      סנן לפי הגעה
      <select value={arrivingFilter} onChange={(e) => setArrivingFilter(e.target.value)}>
        <option value="">הכל</option>
        <option value="0">לא מגיעים</option>
        <option value=">0">מגיעים</option>
        <option value="null">לא ידוע</option>
      </select>
    </label>  
  </div>
  <div className="download-section">
  <button onClick={() => downloadData()}>הורד כקובץ excel </button>
</div>
  <div className="search-section">
  <label>
    חפש לפי שם:
    <input
      type="text"
      value={searchQuery}
      onChange={(e) => setSearchQuery(e.target.value)}
      placeholder="הכנס שם לחיפוש"
    />
  </label>
  <button onClick={handleSearch}>חפש</button>
</div>

</div>


      {/* Table */}
      <div className="table-container">
      <table>
        <thead>
          <tr>
          <th>שם</th>
          <th>טלפון</th>
            <th>כמה יגיעו</th>
            <th>מספר שולחן</th>
            <th>הערה</th>
            <th>לינק אישי לאישור הגעה</th>
          </tr>
        </thead>
        <tbody>
          {filteredInvites.length > 0 ? (
            filteredInvites.map((invite, index) => (
              <tr key={index}>
              <td data-label="שם">{invite.name}</td>
              <td data-label="טלפון">
  {String(invite.phon_number).startsWith('0') ? invite.phon_number : '0' + invite.phon_number}
</td>
              <td data-label="כמה יגיעו">{invite.arriving}</td>
              <td data-label="מספר שולחן">{invite.table_number}</td>
              <td data-label="הערה">{invite.command}</td>
                <td>
                <button
                  onClick={() =>
                    copyToClipboard(
                      `https://mariage-il.com/invitation/confirm/${invite.invitation_url}/`,
                      index
                    )
                  }
                >
                  {copiedIndex === index ? 'הועתק!' : 'העתק'}
                </button>
              </td>
              <td>
                <input
                  type="checkbox"
                  checked={!!editableFields[invite.id]}
                  onChange={() => handleCheckboxChange(invite.id)}
                />
                {editableFields[invite.id] && (
                  <div>
                    <button
                      onClick={() => handleEditClick(invite)}
                    >
                      ערוך
                    </button>
                    <button
                      onClick={() => handleRemoveInvite(invite)}
                    >
                      מחק
                    </button>
                  </div>
                )}
              </td>
              </tr>
            ))
          ) : (
            <tr>
            </tr>
          )}
        </tbody>
      </table>
      </div>
      {showModal && (
        <div className="modal">
          <div className="modal-content">
            <h2>ערוך הזמנה</h2>
            <label>
            שם
            <input
                type="text"
                value={newName}
                onChange={(e) => setNewName(e.target.value)}
              />
            </label>
            <label>
            טלפון
              <input
                type="number"
                value={newPhone}
                onChange={(e) => setNewPhone(e.target.value)}
              />
            </label>
            <label>
              כמה יגיעו
              <input
                type="number"
                value={newArriving}
                onChange={(e) => setNewArriving(e.target.value)}
              />
            </label>
            <label>
              קשר
              <select value={newRelationship} onChange={(e) => setNewRelationship(e.target.value)}>
                {relationshipOptions.map((option) => (
                  <option key={option.value} value={option.value}>{option.label}</option>
                ))}
              </select>
            </label>
            <div className="modal-actions">
              <button onClick={handleSave}>אישור</button>
              <button onClick={handleCancel}>בטל</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Invites;
